export const isUS = country => country === 'US';
